import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import  Home  from "../pages/Home";
import MarketplaceHomePageNewUI from "../pages/MarketplaceHomePageNewUI";
import MerchShop from "../pages/MerchShop";
import QRStudioPage from "../pages/QRStudioPage";
import CreatorLanding from "../creator/CreatorLanding";
import CreatorApply from "../creator/CreatorApply";
import CreatorDashboard from "../creator/CreatorDashboard";
import ReferralRedirect from "../creator/ReferralRedirect";
import AdminCreators from "../creator/AdminCreators";
import AdminCreatorsGate from "../creator/AdminCreatorsGate";
import QRStudioToolStub from "../pages/QRStudioToolStub";
import QRGeneratorPage from "../pages/QRGeneratorPage";
import EventsListingPage from "../pages/EventsListingPage";
import EventDetailPage from "../pages/EventDetailPage";
import InstaPointsPage from "../pages/InstaPointsPage";
import  About  from "../pages/About";
import  Tickets  from "../pages/Tickets";
import  Index  from "../DashBoard/Index";
import  UserDashboardIndex  from "../UserDashboard/Index";
import  Checkout  from "../pages/Checkout";
import  NotFound  from "../pages/NotFound";
import  Category  from "../pages/Category";
import  NewsFeeds  from "../pages/NewsFeeds";
import  Conditions  from "../pages/Conditions";
import  UserProfile  from "../pages/UserProfile";
import MyTicketsPage from "../pages/MyTicketsPage";
import OrganizerPayoutsPage from "../pages/OrganizerPayoutsPage";
import  Login  from "../Components/accounts/Login";
import  GroupDetails  from "../pages/GroupDetails";
import  Registration  from "../pages/Registration";
import  PrivicyPolicy  from "../pages/PrivicyPolicy";
import  NewPaymentPage  from "../pages/NewPaymentPage";
import  ForgotPassword  from "../pages/ForgotPassword";
import  DownloadInvoice  from "../pages/DownloadInvoice";
import CreateEventLandingPage from "../pages/CreateEventLandingPage";
import CreateEventWizard from "../Components/CreateEvent/CreateEventWizard";
import QuickCreateEvent from "../Components/CreateEvent/QuickCreateEvent";
import  EditEventPage  from "../Components/CreateEvent/EditEventPage";
import OrganizerRoute from "../Components/PrivateRoutes/OrganizerRoute";
import UserRoute from "../Components/PrivateRoutes/UserRoute";

// Scanner pages load the camera QR decoder, so they're split out of the main bundle
const OrganizerCheckInPage = lazy(() => import("../pages/OrganizerCheckInPage"));
const DoorScannerPage = lazy(() => import("../pages/DoorScannerPage"));
// Pages shown inside the InstaPass mobile app
const AppHaileyPage = lazy(() => import("../pages/app/AppHaileyPage"));
const AppSeatMapPage = lazy(() => import("../pages/app/AppSeatMapPage"));
const scannerFallback = <div className="min-h-screen bg-[#060D1B]" />;




export default function RouterComponent({ user }) {

    return (
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/marketplace-home" element={<MarketplaceHomePageNewUI />} />
                <Route path="/merch" element={<MerchShop />} />
                <Route path="/events" element={<EventsListingPage />} />
                <Route path="/event/:id" element={<EventDetailPage />} />
                <Route path="/creators" element={<CreatorLanding />} />
                <Route path="/creators/apply" element={<CreatorApply />} />
                <Route path="/creators/dashboard" element={<CreatorDashboard />} />
                <Route path="/r/:code" element={<ReferralRedirect />} />
                <Route path="/qr-studio" element={<QRStudioPage />} />
                <Route path="/qr-studio/create" element={<QRGeneratorPage />} />
                <Route path="/qr-studio/library" element={<QRStudioToolStub />} />
                <Route path="/qr-studio/analytics" element={<QRStudioToolStub />} />
                <Route path="/qr-studio/templates" element={<QRStudioToolStub />} />
                <Route path="/instapoints" element={<InstaPointsPage />} />
                <Route path="/*" element={<NotFound />} />
                <Route path="/login" element={<Login />} />
                <Route path="/aboutUs" element={<About />} />
                <Route path="/tickets" element={<Tickets />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/tickets/:name" element={<Category />} />
                <Route path="/newsfeed/:id" element={<NewsFeeds />} />
                <Route path="/payment" element={<NewPaymentPage />} />
                <Route path="/user/profile" element={<UserProfile />} />
                <Route path="/my-tickets" element={<MyTicketsPage />} />
                <Route path="/app/hailey" element={<Suspense fallback={scannerFallback}><AppHaileyPage /></Suspense>} />
                <Route path="/app/seatmap/:id" element={<Suspense fallback={scannerFallback}><AppSeatMapPage /></Suspense>} />
                <Route path="/door" element={<Suspense fallback={scannerFallback}><DoorScannerPage /></Suspense>} />
                <Route path="/organizer/payouts" element={<OrganizerRoute><OrganizerPayoutsPage /></OrganizerRoute>} />
                <Route path="/organizer/check-in" element={<OrganizerRoute><Suspense fallback={scannerFallback}><OrganizerCheckInPage /></Suspense></OrganizerRoute>} />
                <Route path="/registration" element={<Registration />} />
                <Route path="/privacyPolicy" element={<PrivicyPolicy />} />
                <Route path="/terms&conditions" element={<Conditions />} />
                <Route path="/forgotpassword" element={<ForgotPassword />} />
                <Route path="/create-event" element={<CreateEventLandingPage />} />
                <Route path="/create-event/form" element={<UserRoute><QuickCreateEvent /></UserRoute>} />
                <Route path="/create-event/advanced" element={<UserRoute><CreateEventWizard initialStep={0} /></UserRoute>} />
                <Route path="/create-event-2" element={<UserRoute><CreateEventWizard initialStep={3} /></UserRoute>} />
                <Route path="/create-event-3" element={<UserRoute><CreateEventWizard initialStep={2} /></UserRoute>} />
                <Route path="/create-event-4" element={<UserRoute><CreateEventWizard initialStep={4} /></UserRoute>} />
                <Route path="/edit-event/:eventId" element={<UserRoute><EditEventPage /></UserRoute>} />
                <Route path="/tickets/group.details/:id" element={<GroupDetails />} />
                {user?.role === "admin" && <Route path="/admin/dashboard" element={<Index />} />}
                <Route path="/admin/creators" element={user?.role === "admin" ? <AdminCreators /> : <AdminCreatorsGate signedIn={!!user?.email} />} />
                <Route path="/user/dashboard" element={<OrganizerRoute><UserDashboardIndex /></OrganizerRoute>} />
                <Route path="/invoice/download/:orderId/:itemId" element={<DownloadInvoice />} />
                <Route path="/tickets/group.details/:id/:name" element={<GroupDetails />} />
            </Routes>
    );
}
